module.exports = __webpack_public_path__ + "img/search_engine_optimization.e8b6178a.svg";